import { render, staticRenderFns } from "./addInstitutional.vue?vue&type=template&id=974ff680&scoped=true&"
import script from "./addInstitutional.vue?vue&type=script&lang=js&"
export * from "./addInstitutional.vue?vue&type=script&lang=js&"
import style0 from "./addInstitutional.vue?vue&type=style&index=0&id=974ff680&lang=scss&scoped=true&"
import style1 from "./addInstitutional.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974ff680",
  null
  
)

export default component.exports